import { type Impression, TileType } from './types';

export function getBoostedImpressionsAttributions(impressions: Impression[]) {
  const boostedImpressions = impressions.filter(
    (impression) => impression.tileType === TileType.Boosted
  );
  return boostedImpressions.map((boostedImpression) => ({
    time: boostedImpression.impressionTime,
    product_id: boostedImpression.productId,
  }));
}
